// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SxSy","clinicsSelect":"styles_clinicsSelect__2QOIP"};